// First-visit language: the browser's preferred language when the platform offers it, otherwise the
// user's location (from the device time zone, no network call), otherwise English.
// A saved choice (localStorage LANGUAGE) always wins; this only runs when there is none.

// Time zones whose users get a non-English default even when their browser is set to English.
const TIMEZONE_LANGUAGE = {
  // Brazil
  'America/Sao_Paulo': 'pt',
  'America/Rio_Branco': 'pt',
  'America/Manaus': 'pt',
  'America/Belem': 'pt',
  'America/Fortaleza': 'pt',
  'America/Recife': 'pt',
  'America/Bahia': 'pt',
  'America/Maceio': 'pt',
  'America/Araguaina': 'pt',
  'America/Cuiaba': 'pt',
  'America/Campo_Grande': 'pt',
  'America/Porto_Velho': 'pt',
  'America/Boa_Vista': 'pt',
  'America/Santarem': 'pt',
  'America/Noronha': 'pt',
  'America/Eirunepe': 'pt',
  'Brazil/East': 'pt',
  'Brazil/West': 'pt',
  'Brazil/Acre': 'pt',
  'Brazil/DeNoronha': 'pt',
};

export function detectInitialLanguage(supported, fallback = 'en') {
  const preferred = (navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language])
    .map((tag) => String(tag || '').toLowerCase().split('-')[0])
    .find((code) => supported.includes(code));
  if (preferred && preferred !== fallback) return preferred;

  let timeZone;
  try {
    timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (e) {
    timeZone = null;
  }
  const byLocation = TIMEZONE_LANGUAGE[timeZone];
  if (byLocation && supported.includes(byLocation)) return byLocation;

  return preferred || fallback;
}
